module.exports = __webpack_public_path__ + "static/img/honor-1.924d594.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/honor-1.png
// module id = g6uO
// module chunks = 0